import {GrowthBook} from '@growthbook/growthbook';
import {analyticsLogger} from 'analytics/analyticsLogger';
import {isProd} from 'helpers/environment';

export const GROWTHBOOK_APP_ORIGIN = 'https://app.dropboxexperiment.com';

export type GrowthbookTempOverrideLinkValue = 'ON' | 'OFF';

export function getGrowthbookAppFeatureUrl(featureId: string): string {
  return `${GROWTHBOOK_APP_ORIGIN}/features/${encodeURIComponent(featureId)}`;
}

export function buildGrowthbookTempOverrideUrl(
  growthbookFeatureId: string,
  options?: {
    baseUrl?: string;
    value?: GrowthbookTempOverrideLinkValue;
    ttlMinutes?: number;
  }
): string {
  const baseUrl = options?.baseUrl ?? `${window.location.pathname}${window.location.search}`;
  const url = new URL(baseUrl, window.location.origin);
  url.searchParams.set(growthbookFeatureId, options?.value ?? 'ON');

  if (options?.ttlMinutes !== undefined && options.ttlMinutes > 0) {
    url.searchParams.set('ttl', String(options.ttlMinutes));
  }

  return url.toString();
}

export const growthbook = new GrowthBook({
  apiHost: 'https://cdn.dropboxexperiment.com',
  clientKey: isProd ? 'sdk-CER3PbqP0ZQNOj3' : 'sdk-BcTM4q0VykUceUSY',
  enableDevMode: true,
  disableCache: true,
  subscribeToChanges: true,
  trackingCallback: (experiment, result) =>
    analyticsLogger().logEvent('LOG_EXPERIMENT', {
      experimentId: experiment.key,
      variationId: result.key,
    }),
});
